import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Spinner as Loader } from 'reactstrap';
import { ControlePrestatiesClient } from '../client/procescontroleclient';
import PageTitle from '../components/UI/PageTitle';
import PageWrapper from '../components/UI/PageWrapper';
import styled from 'styled-components';
import ProcesControlePrestatiesKubus from './ProcesControlePrestatiesKubus';
import ProcesControlePrestatiesOverig from './ProcesControlePrestatiesOverig';

const Grid = styled.div`
  margin-top: 2rem;
  display: grid;
  gap: 20px;
  @media(max-width: 480px) {
    grid-template-columns: none;
  }

  display: grid;
  grid-template-columns: 1fr 1.3fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  gap: 2rem;
`

export default function ProcesControlePrestaties() {

  useEffect(() => {
    const interval = setInterval(() => {
      prestatiePickerQuery.refetch();
      prestatieKubusQuery.refetch();
    }, 60000);
    return () => clearInterval(interval);
  })

  const prestatieClient = new ControlePrestatiesClient(process.env.REACT_APP_APIURL);

  const prestatiePickerQuery = useQuery(['controlePrestatiePicker'],
    async () => await prestatieClient.getPickerPrestatieRegels(),
    { staleTime: Infinity }
  );

  const prestatieKubusQuery = useQuery(['controlePrestatieKubussen'],
    async () => prestatieClient.getKubusPrestatieRegels(),
    { staleTime: Infinity }
  );

  const prestatiePackagerQuery = useQuery(['controlePrestatiePackager'],
    async () => prestatieClient.getPackagerPrestatieRegels(),
    { staleTime: Infinity }
  );

  const queries = [{ query: prestatiePickerQuery, name: 'Pickers' }, { query: prestatieKubusQuery, name: 'Kubus' }, { query: prestatiePackagerQuery, name: 'Inpakkers' }]

  return (
    <PageWrapper>
      <PageTitle>Controle Prestaties</PageTitle>
      <Grid>
        {queries.map((item) => {
          if (item.query.isLoading) {
            return <Loader key={item.name} />
          } else {
            if (item.name === 'Kubus') {
              return (
                <ProcesControlePrestatiesKubus 
                    name={item.name} 
                    data={item.query.data!} />
              )}
              else {
                return (
                  <ProcesControlePrestatiesOverig 
                      name={item.name} 
                      data={item.query.data!} />
                )  
            }
          }
        })}
      </Grid>
    </PageWrapper>
  );
}